import { Heading } from '@/hen-ui/atomics/Heading';
import { Flex } from '@/hen-ui/composites/Flex';

import { CareerExplorerSkillPill } from './CareerExplorerSkillPill';
import type { CareerExplorerSkill } from './types';

interface CareerExplorerSkillPillsProps {
  heading: string;
  skills: CareerExplorerSkill[];
}

export const CareerExplorerSkillPills = ({
  heading,
  skills,
}: CareerExplorerSkillPillsProps) => (
  <Flex gap='sm' className='order-last md:order-none'>
    <Heading variant='h4' color='secondary'>
      {heading}
    </Heading>

    <Flex direction='row' gap='sm' wrap='wrap'>
      {skills.map((skill) => (
        <CareerExplorerSkillPill key={skill.id} label={skill.label} />
      ))}
    </Flex>
  </Flex>
);
